import { getDicts, bankList } from "@/api/common";
const state = {
  questionBanks: [],
  questionTags: []
}

// actions
const actions = {
  initExamOptions({ dispatch }) {
    dispatch('initQuestionBanks');
    dispatch('initQuestionTags');
  },
  initQuestionBanks({ commit }) {
    bankList().then(res => {
      commit('SET_QUESTION_BANKS', res.data)
    })
  },
  initQuestionTags({ commit }) {
    getDicts("QUESTION_TAG").then((res) => {
      commit('SET_QUESTION_TAGS', res.data)
    });
  }
}

// mutations
const mutations = {
  SET_QUESTION_BANKS: (state, banks) => {
    state.questionBanks = banks
  },
  SET_QUESTION_TAGS: (state, tags) => {
    state.questionTags = tags
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
